export const state = {
  selectedDate: new Date()
}